import React, { useState } from "react";
import { Container, Box } from "@mui/material";
import JobConfigurationDialog from "./Dialogues/JobConfigurationDialog";
import { usePipelineContext } from "../../../contexts/PipelineContext";
import { jobTypes } from "../../../config/jobTypes";
import { createJob } from "../../../utils/jobManager";
import DraggableList from "../../layout/Interactive/DraggableList";
import { defaultJobs } from "../../../config/pipelineConfig";
import DialogMapper from "./Dialogues/DialogueMapper";
import { useJobConfigurationContext } from "../../../contexts/JobConfigurationContext";

function JobConfigurationSection({
  handleJobUpdate,
  setOrderedJobs,
  orderedJobs,
  addJob,
  handleJobRemove
}) {
  const {
    activeJob,
    setActiveJob,
    selectedUsers,
    unsavedChanges,
    setUnsavedChanges,
    setPipelineJobName,
    pipelineJobName
  } = useJobConfigurationContext();

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          flex: 1,
        }}
      >
        <DraggableList
          setItems={setOrderedJobs ?? (() => {})}
          items={orderedJobs}
          onAddJob={(job) => {
            addJob(job);
            setUnsavedChanges(true);
          }}
          onEditClick={(item) => {
            setActiveJob(item)
            setPipelineJobName("");
          }}
          onRemoveJob={handleJobRemove}
          styleMap={{
            job: { backgroundColor: "#86d3db" },
            qa: { backgroundColor: "#89db86" },
            function: { backgroundColor: "#dba786" },
          }}
          menuItems={defaultJobs}
        />
        {activeJob && (
          <DialogMapper selectedUsers={selectedUsers}/>
        )}
      </Box>
    </Container>
  );
}

export default JobConfigurationSection;
